import React from 'react'

const EmptyState = ({emptyStateTitle, emptyStateText}) => {
  return (
    <div className='flex flex-col items-center justify-center px-5 text-center'>
      <span className='flex h-12 w-12 items-center justify-center rounded-full bg-vcm-light-purple/30 text-vcm-purple'>
        <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' className='h-6 w-6' aria-hidden='true'><path strokeLinecap='round' strokeLinejoin='round' d='M2.25 18.75a60.07 60.07 0 0 1 15.797 2.104c1.049.279 2.078-.59 2.078-1.675V18M3.75 4.5h16.5v12H3.75v-12Z' /><path strokeLinecap='round' d='M7.5 8.25h9m-9 3h6' />
        </svg>
      </span>
      {emptyStateTitle && emptyStateTitle !== '' && <h3 className='mt-4 text-sm font-semibold text-gray-900'>{emptyStateTitle}</h3>}
      {emptyStateText && emptyStateText !== '' && <p className='mt-1 text-sm text-vcm-dark-gray'>{emptyStateText}</p>}
    </div>
  )
}

export default EmptyState